<template>
  <tr-show-for-roles :roles="appRoles.ADMIN">
    <billing-closed
      v-if="billing"
      :billing-month="billingMonth"
      :amount-of-transfers="billing.amount_of_transfers"
      :billing-total="billing.total"
      :no-margin="noMargin"
      :invoice-id="billing.id"
      :eletronic-invoice-url="billing.electronic_invoice_url"
      :get-monthly-report="getMonthlyReport"
      :download-billet="downloadBillet"
      :is-billet-downloading="isBilletDownloading"
    />
  </tr-show-for-roles>
</template>

<script setup>
import { ref, computed } from 'vue';
import BillingClosed from '@/apps/admin/billing/components/presentational/BillingClosed.vue';
import billingResource from '@/apps/admin/billing/resources/billing';
import { useBilletDownload } from '@/apps/admin/billing/composables/useBilletDownload';
import { useToaster } from '@/commons/composables/useToaster';
import { getMessage } from '@/commons/services/error';
import { roles } from '@transfeeradev/api-enums';
import moment from '@transfeeradev/moment';

defineProps({
  noMargin: {
    required: false,
    type: Boolean,
    default: false
  }
});

const toaster = useToaster();
const { isDownloading, download } = useBilletDownload();

const appRoles = roles.appRoles;
const billing = ref(null);
const billingMonth = ref('');

const isBilletDownloading = computed(() => {
  const invoiceId = billing.value?.id;

  return String(invoiceId ?? '').trim() ? isDownloading(invoiceId) : false;
});

const downloadBillet = () => {
  return download(billing.value?.id);
};

const getMonthlyReport = async () => {
  try {
    await billingResource.getMonthlyReport(billing.value.billing_period_start);
    toaster.success({
      message: 'Relatório está sendo gerado, quando concluído será enviado para o seu email.',
      duration: 10000
    });
  } catch (error) {
    toaster.error(getMessage(error));
  }
};

billingResource.payRequest().then(
  response => {
    if (response && response.billing_period_start) {
      billing.value = response;
      billingMonth.value = moment(response.billing_period_start).format('MMMM');
    }
  },
  error => toaster.error(getMessage(error))
);
</script>
